// Una nota en la linea de tiempo (persona, empresa u oportunidad): se lee con formato y se puede editar o borrar.
import { useState } from 'react';

import * as crm from '../api/crm';
import type { Nota } from '../api/types';
import { ago } from '../lib/format';
import { IconDot } from './bits';
import { Texto } from './Texto';
import { toast } from './toasts';

export function NotaItem({ n, onCambio }: { n: Nota; onCambio: () => void }) {
  const [editando, setEditando] = useState(false);
  const [texto, setTexto] = useState(n.cuerpo || n.titulo);
  const [confirmar, setConfirmar] = useState(false);
  const [trabajando, setTrabajando] = useState(false);

  const guardar = async () => {
    if (!texto.trim()) return;
    setTrabajando(true);
    try {
      await crm.editarNota(n.id, texto);
      toast('Nota guardada.');
      setEditando(false);
      onCambio();
    } catch (e) {
      toast((e as Error).message, 'error');
    } finally {
      setTrabajando(false);
    }
  };
  const borrar = async () => {
    if (!confirmar) return setConfirmar(true);
    setTrabajando(true);
    try {
      await crm.borrarNota(n.id);
      toast('Nota borrada.');
      onCambio();
    } catch (e) {
      toast((e as Error).message, 'error');
      setTrabajando(false);
    }
  };

  return (
    <article className="tl-item">
      <IconDot name="note" />
      <div style={{ minWidth: 0 }}>
        <div className="tl-top">
          <b>Nota</b>
          {n.autor ? <span className="sb">{n.autor}</span> : null}
          <time>{ago(n.creado)}</time>
          {!editando ? (
            <span className="nota-acc">
              <button className="btn sm ghost" onClick={() => setEditando(true)}>
                Editar
              </button>
              <button className={`btn sm ${confirmar ? 'danger' : 'ghost'}`} onClick={borrar} disabled={trabajando}>
                {confirmar ? 'Sí, borrar' : 'Borrar'}
              </button>
            </span>
          ) : null}
        </div>
        {editando ? (
          <div className="form" style={{ gap: 8 }}>
            <textarea value={texto} onChange={(e) => setTexto(e.target.value)} rows={4} aria-label="Texto de la nota" autoFocus />
            <div className="actions">
              <button className="btn ghost sm" onClick={() => (setEditando(false), setTexto(n.cuerpo || n.titulo))}>
                Cancelar
              </button>
              <button className="btn primary sm" onClick={guardar} disabled={trabajando || !texto.trim()}>
                {trabajando ? 'Guardando…' : 'Guardar'}
              </button>
            </div>
          </div>
        ) : (
          <div className="tl-body">
            <Texto texto={n.cuerpo || n.titulo} />
          </div>
        )}
      </div>
    </article>
  );
}
